<!-- 需求耗时分布 -->
<template>
  <div>
    <a-card size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">需求耗时分布</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间: 需求耗时分布</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <a-table :data-source="data">
        <a-table-column key="months" title="月份">
          <template slot-scope="record">
            <span>
              {{ record.months }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="需求问答中-待需求方案">
          <template slot-scope="record">
            <span>
              {{ record[135]||0 }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="待需求方案-待开发">
          <template slot-scope="record">
            <span>
              {{ record[136]||0 }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="待开发-开发中">
          <template slot-scope="record">
            <span>
              {{ record[137] }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="开发中-待验收">
          <template slot-scope="record">
            <span>
              {{ record[138]||0 }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="待验收-验收中">
          <template slot-scope="record">
            <span>
              {{ record[139]||0 }}
            </span>
          </template>
        </a-table-column>
        <a-table-column title="验收中-已交付">
          <template slot-scope="record">
            <span>
              {{ record[140]||0 }}
            </span>
          </template>
        </a-table-column>
        <a-table-column key="action" title="合计">
          <template slot-scope="record">
            <span>
              {{ sumRow(record) }}
            </span>
          </template>
        </a-table-column>
      </a-table>
    </a-card>
    <div v-if="data && data.length > 0 && data[index].taskList">
      <task-list-time-modal ref="taskListModal" :task-list="data[index].taskList" />
    </div>
  </div>
</template>
<script>
import TaskListTimeModal from '@/pages/data/task/components/TaskListTimeModal';
export default {
  components: { TaskListTimeModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '500px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    },
    data: {
      type: Array,
      default: () => {
        return [];
      }
    }
  },
  data() {
    return {
      showModal: 'person',
      index: 0
    };
  },
  watch: {

  },
  mounted() {

  },
  beforeDestroy() {

  },
  methods: {
    sumRow(row) {
      let sum = 0;
      parseFloat(row[135]) ? sum += parseFloat(row[135]) : 0;
      parseFloat(row[136]) ? sum += parseFloat(row[136]) : 0;
      parseFloat(row[137]) ? sum += parseFloat(row[137]) : 0;
      parseFloat(row[138]) ? sum += parseFloat(row[138]) : 0;
      parseFloat(row[139]) ? sum += parseFloat(row[139]) : 0;
      parseFloat(row[140]) ? sum += parseFloat(row[140]) : 0;

      return sum.toFixed(2);
    },
    getData(buildTableData) {
      const timeList_135 = [];
      const timeList_136 = [];
      const timeList_137 = [];
      const timeList_138 = [];
      const timeList_139 = [];
      const timeList_140 = [];
      this.option.series = [
        {
          type: 'bar',
          name: '需求问答中-待需求方案',
          data: timeList_135,
          stack: 'cost'
        },
        {
          type: 'bar',
          name: '待需求方案-待开发',
          data: timeList_136,
          stack: 'cost'
        },
        {
          type: 'bar',
          name: '待开发-开发中',
          data: timeList_137,
          stack: 'cost'
        },
        {
          type: 'bar',
          name: '开发中-待验收',
          data: timeList_138,
          stack: 'cost'
        },
        {
          type: 'bar',
          name: '待验收-验收中(天)',
          data: timeList_139,
          stack: 'cost'
        },
        {
          type: 'bar',
          name: '验收中-已交付(天)',
          data: timeList_140,
          stack: 'cost'
        }
      ];
      this.drawChart();
    },

    onDetail(index) {
      this.index = index;
      this.$refs.taskListModal.open();
    }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
